module.exports = __webpack_public_path__ + "static/media/marina-61e1818cfc0849aedb88991f1b809145.b586ae7e.png";